import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../Icon";

export const Button = ({type, svg, text, action, size, full, loading, link, style, disabled, btnClass, badge}) => {
    const navigate = useNavigate();
    const hasBadge = Number(badge) > 0;

    let className = `button ${type ? type : 'primary'}`;
    className += size ? ` ${size}` : ' regular';
    className += btnClass ? ` ${btnClass}` : '';
    className += hasBadge ? ' has-badge' : '';

    if(svg){
        className += ' has-svg';
    }

    if(full){
        className += ' full';
    }

    const handleOnClick = event => {
        if(!link){
            action();
            return;
        }

        if (
            event.ctrlKey ||
            event.shiftKey ||
            event.metaKey || // apple
            (event.button && event.button == 1) // middle click, >IE9 + everyone else
        ){
            window.open(link);
        } else {
            navigate(link);
        }
    }

    // Os ícones históricos são arquivos em assets/images/svgs. As telas de
    // Painéis usam nomes do Lucide (via componente Icon), que não têm arquivo
    // correspondente — quando o require falha, cai no Icon.
    const renderSvg = () => {
        try {
            return <img src={ require(`../../assets/images/svgs/${svg}.svg`) } alt="" />;
        } catch (e) {
            return <Icon name={svg} size={size === 'small' ? 14 : 16} strokeWidth={2.25} />;
        }
    }

    return (
        <button className={className} style={style ?? null} onClick={handleOnClick} disabled={loading === true || disabled === true}>
            {loading ? 'Carregando...' : text}
            {svg && renderSvg()}
            {hasBadge &&
                <span className="button-badge">{badge}</span>
            }
        </button>
    );
}

export default Button;
